import { defineStore } from 'pinia'
import axios from '@/utils/axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: sessionStorage.getItem('token') || null,
    refreshToken: sessionStorage.getItem('refreshToken') || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    isAdmin: (state) => state.user?.role === 'admin' || state.user?.role === 'sys_admin',
    isEmployee: (state) => state.user?.role === 'employee',
    fullName: (state) => state.user?.full_name || '',
  },

  actions: {
    async login(username, password) {
      try {
        const response = await axios.post('/api/users/login/', {
          username,
          password
        })

        this.token = response.data.access
        this.refreshToken = response.data.refresh
        this.user = response.data.user

        sessionStorage.setItem('token', this.token)
        sessionStorage.setItem('refreshToken', this.refreshToken)

        return response.data
      } catch (error) {
        throw error
      }
    },

    async fetchUser() {
      try {
        const response = await axios.get('/api/users/me/')
        this.user = response.data
        return response.data
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async uploadAvatar(file) {
      const formData = new FormData()
      formData.append('avatar', file)
      const response = await axios.patch('/api/users/upload_avatar/', formData)
      this.user = response.data
      return response.data
    },

    async updateMe(data) {
      const response = await axios.patch('/api/users/update_me/', data)
      this.user = response.data
      return response.data
    },

    async changePassword(oldPassword, newPassword) {
      try {
        const response = await axios.post('/api/users/change_password/', {
          old_password: oldPassword,
          new_password: newPassword
        })
        return response.data
      } catch (error) {
        throw error
      }
    },

    logout() {
      this.user = null
      this.token = null
      this.refreshToken = null
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('refreshToken')
    }
  }
})
